import { Activity } from "projects/mijn/src/app/activity/models/activity";
import { BasicDto, IdObject } from "../../_shared/models/basicDto";
import { PersonDto } from "../../person/models/person";
import { PolicyArea } from "../../volunteers/models/policy-area";
import { WorkGroupMinimal } from "../../volunteers/models/workgroup";

export const IncreasedExpenseYearMax = 3233.91;
export const ExpenseYearMax = 1760.83;
export const ExpenseDayMax = 44.02;

export interface ExpenseItem extends IdObject<number> {
  PersonId?: number;
  //Person: string;  // TOEGEVOEGD DOOR VINCENT VOOR PRESENTATIE
  Description: string;
  TotalAmount: number;
  ExpenseItemTypeId: number;
  ExpenseType?: ExpenseItemType;
  AccountId?: number;
  TaskId?: number;
  FeeCategoryId?: number;
  FeeCategory?: FeeCategory;
  RelocationTypeId?: number;
  ActivityId?: number;
  Activity?: Activity;
  WorkGroupId?: number;
  //RelocationReason?: string;
  AmountPerKm?: number;
  km?: number;
  DocumentUrl?: string;
  //PaymentDate?: Date;
  ValidationDate?: Date | null;
  ValidatedDate?: Date;
  ValidatedByPersonId?: number;
  ValidatedByUserId?: number | null;
  Date: Date;
  ExpenseReportId?: number;
  ExpenseReport?: ExpenseReportBasic;
  CreationDate: string;
  StatusId?: ExpenseItemStatusEnum | null; // 0 = afgekeurd, 1 = goedgekeurd
  Person: PersonDto;
  WorkGroup: WorkGroupMinimal | null;
}

export interface ExpenseItemWithTotals extends ExpenseItem {
  YearTotal: number;
  IncreasedYearTotal: number;
  DayTotal: number;
}

export interface ExpenseReportBasic extends IdObject<number> {
  PersonId: number;
  Person: PersonDto;
  From: string;
  Till: string;
  TotalAmount: number;
  ExpenseItems?: ExpenseItem[];
  Paid?: string;
  CreationDate: string;
  ValidatedDate?: string;
  StatusId: number;
  SendForPayment: Date | null;
  Selected: boolean;
  PolicyAreaId: number | null;
  PolicyArea: PolicyArea | null;
}

export interface ExpenseReportExpanded extends ExpenseReportBasic {
  PolicyArea: PolicyArea | null;
}

export interface Name {
  FirstName: string;
  LastName: string;
}

interface VolunteerMoment extends IdObject<number> {
  VolunteerId: number;
  TaskId: number;
  Fee: number;
  ExpenseItemId: number;
}

interface Task extends BasicDto<number> {
  Description: string;
  //Fee?: number;
  FeeCategoryId: number;
}

export interface ExpenseFeeCategoryWorkgroupBasic extends IdObject<number> {
  ExpenseFeeCategoryId?: number;
  WorkgroupId?: number;
}

export interface FeeCategory extends BasicDto<number> {
  Amount: number;
  MeasureAmount: string; // TOEGEVOEGD DOOR VINCENT VOOR PRESENTATIE
  FeeTypeId?: number;
  ExpenseItemTypeId: ExpenseItemType | number;
  ExpenseItemType: ExpenseItemType; // TOEGEVOEGD DOOR VINCENT VOOR PRESENTATIE
  RelocationTypeId?: RelocationType | number;
  FeeCategoryWorkgroups: ExpenseFeeCategoryWorkgroupBasic[];
  ExpenseItemsCount: number;
}

interface FeeType extends BasicDto<number> {
  Description: string;
  AvailableFrom: Date;
  AvailableTill: Date;
}

interface FeeTypePeriod extends IdObject<number> {
  FeeTypeId: number;
  From: Date;
  Till: Date;
  YearLimit: number;
  DayLimit: number;
}

interface Volunteer extends BasicDto<number> {
  RegistryNumber: string;
}

interface Organization extends IdObject<number> {
  CarRate: number;
  BikeRate: number;
}

export enum ExpenseItemTypeEnum {
  FIXED = 1,
  ACTUAL = 2,
  RELOCATION = 3,
  DONATION = 4,
}

export enum ExpenseItemStatusEnum {
  PENDING_VALIDATIOn = -1, //Only for filtering
  DENIED = 0,
  ACCEPTED = 1,
}

export interface ExpenseItemType extends BasicDto<number> {}

enum RelocationType {
  Car = "Car",
  Bike = "Bike",
  PublicTransport = "PublicTransport",
}

enum AccountingCategory {
  Car = "613310",
  Train = "613311",
  Restaurant = "613320",
  Hotel = "613313",
  Other = "Other",
}

export interface ExpenseTotal {
  total: number;
  increasedTotal: number;
}
